import React from 'react';
import { FormattedMessage } from 'react-intl';

import HorizontalStackBlock from 'blocks/HorizontalStackBlock';
import ItemStackBlock from 'blocks/ItemStackBlock';
import IconComponent from 'components/IconComponent';
import Paragraph from 'components/Paragraph/Paragraph';
import Headline from 'elements/Headline';
import NakedLink from 'elements/NakedLink';
import { textileOrderRoute } from 'utils/history/textile-order-route';
import TextileDashboardArrowComponent from '../components/TextileDashboardArrowComponent';

export const TextileCalculatorBlockComponent = ({
  textileOrderId,
  locked
}: {
  textileOrderId: number;
  locked: boolean;
}) => {
  if (locked) {
    return (
      <HorizontalStackBlock justified={true} gap="XS" centered={true}>
        <IconComponent
          icon="CALCULATOR"
          roundBackground="GRAY950"
          size={3.5}
          square={true}
          fill="GRAY800"
        />
        <ItemStackBlock gap="XXS">
          <Headline.Small color="GRAY560">
            <FormattedMessage id="Textile calculator" />
          </Headline.Small>

          <Paragraph color="GRAY560">
            <IconComponent icon="LOCK" fill="GRAY400" />
            <FormattedMessage id="Editing deactivated" />
          </Paragraph>
        </ItemStackBlock>
        <TextileDashboardArrowComponent status={'locked'} />
      </HorizontalStackBlock>
    );
  }

  return (
    <NakedLink
      to={textileOrderRoute(undefined, '/calculator', textileOrderId)}
    >
      <HorizontalStackBlock justified={true} gap="XS" centered={true}>
        <IconComponent
          icon="CALCULATOR"
          roundBackground="PRIMARY"
          size={3.5}
          square={true}
          fill="WHITE"
        />
        <ItemStackBlock gap="XXS">
          <Headline.Small>
            <FormattedMessage id="Textile calculator" />
          </Headline.Small>
          <Paragraph color="TEXT_LIGHT">
            <FormattedMessage id="textile calculator price" />
          </Paragraph>
        </ItemStackBlock>
        <TextileDashboardArrowComponent status="open" />
      </HorizontalStackBlock>
    </NakedLink>
  );
};

export default TextileCalculatorBlockComponent;
